import { services2 } from '/api/services2';
import { store } from '/store/store';
import { logout } from '/store/toolkits/auth/actions';
import { systemRehydrate } from '/store/systemActions';
import { initListeners as initAuthListeners } from '/store/toolkits/auth/listeners';
import { initListeners as initAppListeners } from '/store/toolkits/app/listeners';
import { initListeners as initSpaceListeners } from '/store/toolkits/space/listeners';
import { initListeners as initUIListeners } from '/store/toolkits/ui/listeners';
import { buzzerAppNotifications } from '/common/buzzer';

export const setupAppInterceptors = () => {
  services2.transport.onFailureEx = ({ code }) => {
    if (code === 401) {
      store.dispatch(logout());
    }
  };
};

export const initAppStore = () => {
  store.dispatch(systemRehydrate());
};
export const initServices = () => {
  buzzerAppNotifications.init(store);
};
export const initAllListeners = () => {
  initAuthListeners();
  initAppListeners();
  initSpaceListeners();
  initUIListeners();
};

export const initApp = () => {
  initAllListeners();

  setupAppInterceptors();
  initServices();

  initAppStore();
};
